import { withDependencies } from '@wix/thunderbolt-ioc'
import type { ITpaCommonsSideEffects } from '../types'
import { name, TpaSrcUtilitySymbol } from '../symbols'
import { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { ITpaSrcUtility } from '../types'

export const TpaCommonsSideEffects = withDependencies(
	[TpaSrcUtilitySymbol],
	({ rebuildTpasSrc }: ITpaSrcUtility): IModelUpdatesHandlersImplementor<ITpaCommonsSideEffects> => ({
		featureName: name,
		handlers: {
			rebuildAllTpasSrc() {
				rebuildTpasSrc()
			},
		},
	})
)
